//---- components ---------
//---- mixins -------------
//---- services -----------
import NotificationService from "@/app/services/notification";
//---- other --------------
import { admin, initialState as adminInitialState } from './admin.module';
import { advisorCustom, initialState as advisorCutomInitialState } from './../customers/store/advisor-custom.module';
import { auth } from './auth.module.js';
import { authoring, initialState as authoringInitialState } from './authoring.module';
import { draft, initialState as draftInitialState } from './draft.module';
import { dsDashboard, initialState as dsInitialState } from './ds.module';
import { header, initialState as headerInitialState } from './header.module';
import { kmOffline, initialState as kmOfflineInitialState } from './kmoffline.module';
import { projectData, initialState as projectDataInitialState } from './projectHome.module';
//---- 3rd-parties --------
import Vue from 'vue';
import vueI18n from "@/app/services/i18n.service.js"
import Vuex from 'vuex';

Vue.use(Vuex);

// initial state
let initialState = {
  // auth: auth.initialState,
  header: headerInitialState,
  projectData: projectDataInitialState,
  admin: adminInitialState,
  dsDashboard: dsInitialState,
  authoring: authoringInitialState,
  draft: draftInitialState,
  errorMessage: '',
  globalLoadingOverlay: false,  // show a loading overlay over the entire screen
  advisorCustom: advisorCutomInitialState,
  notifications: [],
  lastNotificationId: 0,
  webpLossySupport: true, // browser support for webp lossy format (jpg replacement)
  kmOfflineState: kmOfflineInitialState
}

export default new Vuex.Store({

  modules: {
    auth,
    header,
    projectData,
    admin,
    dsDashboard,
    authoring,
    draft,
    advisorCustom,
    kmOffline
  },

  state: {
    applicationErrorMessage: '',                // error message that prevents the app from starting
    errorMessage: initialState.errorMessage,
    backendUrl: '',
    viewport: { width: -1, height: -1 },        // (internal window size) in pixels
    globalLoadingOverlay: initialState.globalLoadingOverlay, // show a loading overlay over the entire screen
    globalLoadingOverlayReason: "",             // for debugging purpose
    notifications: initialState.notifications,  // the toasts
    lastNotificationId: initialState.lastNotificationId,
    webpLossySupport: initialState.webpLossySupport, // browser support for webp lossy format (jpg replacement)
    kmOfflineState: initialState.kmOfflineState,
    skdVersion: process.env.SKD_VERSION,
    copyrightYear: process.env.COPYRIGHT_YEAR,
  },

  actions: {
    onLogin({ commit }) {
      commit('reset')
    },
    onLogout({ commit }) {
      commit('auth/logout')
      commit('reset')
    },
    onTimeout({ commit }) {
      commit('auth/onTimeout')
      commit('header/onLogout')
    },
    setBackendUrl({ commit }, url) {
      // make sure the url doesn't end with a forward slash
      commit('setBackendUrl', url.replace(/\/$/, ''))
    },
    backendUnreachable({ commit }) {
      commit('setErrorMessage', 'backend-unreachable');
    },
    setErrorMessage({ commit }, errorMessage) {
      commit('setErrorMessage', errorMessage);
    },
    onViewportSizeChange({ commit }, veiwportSize) {
      commit('setViewportSize', veiwportSize);
    },
    showGlobalLoadingOverlay({ commit }, reason) {
      commit('showGlobalLoadingOverlay', reason)
    },
    hideGlobalLoadingOverlay({ commit }, reason) {
      commit('hideGlobalLoadingOverlay', reason)
    },
    webpLossySupport({ commit }, isSupported) {
      commit('webpLossySupport', isSupported)
    },
    applicationError({ commit }, message) {
      commit('onApplicationError', message)
    }
  },
  mutations: {
    showGlobalLoadingOverlay(state, reason) {
      state.globalLoadingOverlay = true;
      state.globalLoadingOverlayReason = reason; // this is for debugging
    },
    hideGlobalLoadingOverlay(state, reason) {
      state.globalLoadingOverlay = false;
      state.globalLoadingOverlayReason = reason; // this is for debugging
    },
    setErrorMessage(state, errorMessage) {
      if (state.errorMessage == errorMessage)
        return;
      if (errorMessage == 'backend-unreachable')
        NotificationService.error(vueI18n.t('error.backend-unreachable'), 'backend-unreachable');
      state.errorMessage = errorMessage;
    },
    setBackendUrl(state, backendUrl) {
      state.backendUrl = backendUrl;
    },
    setViewportSize(state, viewportSize) {
      state.viewport = viewportSize
    },
    onApplicationError(state, message) {
      state.applicationErrorMessage = message
    },
    // this adds a notification to the toasts and leave the id for grab in 
    // lastNotificationId. Because js is single threaded, there won't be a race
    // condition if we get the value imediatly after.
    addNotification(state, notification) {
      // we first check if the notification is a duplicate, if that's the case
      // we don't want to display it a second time, we'll put a pill instead
      // with the number of repeats
      if (state.notifications.length > 0) {
        const lastNotification = state.notifications[state.notifications.length - 1];
        if (lastNotification.message === notification.message && lastNotification.htmlMessage === notification.htmlMessage) {
          lastNotification.repeat++;
          return;
        }
      }

      if (typeof notification.id === 'undefined') {
        ++state.lastNotificationId
        notification.id = "" + state.lastNotificationId
      }
      notification.repeat = 1;
      state.notifications.push(notification)
    },
    removeNotification(state, idToRemove) {
      state.notifications = state.notifications.filter((notification) => notification.id != idToRemove)
    },
    clearAllNotification(state) {
      state.notifications = []
    },
    reset(state) {
      // preserve the factory settings for css
      const cssFactorySettings = state.admin.styleFactorySettings;
      Object.keys(state).forEach(key => {
        if (key !== 'backendUrl' && key !== 'viewport')
          Object.assign(state[key], initialState[key])
      })
      state.admin.styleFactorySettings = cssFactorySettings;
    },
    webpLossySupport(state, isSupported) {
      state.webpLossySupport = isSupported;
    }
  },
  getters: {
    backendUrl(state) {
      return state.backendUrl;
    },
    errorMessage(state) {
      return state.errorMessage;
    },
    viewportSize(state) {
      return state.viewport;
    },
    globalLoadingOverlay(state) {
      return state.globalLoadingOverlay;
    },
    lastNotificationId(state) {
      return state.lastNotificationId;
    },
    xs(state) {
      return state.viewport.width > 0 && state.viewport.width < 576;
    },
    sm(state) {
      return state.viewport.width >= 576;
    },
    md(state) {
      return state.viewport.width >= 768;
    },
    lg(state) {
      return state.viewport.width >= 992;
    },
    xl(state) {
      return state.viewport.width >= 1200;
    },
    // this indicates that the screen is too narrow for 
    // desktop layout
    mobileLayout(state) {
      return state.viewport.width > 0 && state.viewport.width < 768;
    },
    // this indicates that the screen is too narrow for 
    // desktop layout
    desktopLayout(state) {
      return state.viewport.width >= 768;
    },
    // breakpoint(state) {
    //   const w = state.viewportSize.width;
    //   if (w < 576) 
    //     return 'xs';
    //   else if (w >= 1200) 
    //     return 'xl';
    //   else if (w >= 992) 
    //     return 'lg';
    //   else if (w >= 678) 
    //     return 'md';
    //   else if (w >= 576) 
    //     return 'sm';
    // }
    webpLossySupport(state) {
      return state.webpLossySupport;
    },
    applicationErrorMessage(state) {
      return state.applicationErrorMessage
    },
  }
});